module.exports = __webpack_public_path__ + "a434a148589da502665c3281a1be7573.png";